/**
 * iOS raises the keyboard only for a focus made inside the user's tap. When a
 * tap reveals a field that mounts (or focuses) a frame later — a search
 * behind a trigger, a composer that opens on Reply — call this in the tap
 * handler: a hidden input takes focus now, opening the keyboard, and the
 * real field inherits it when it focuses (a focus passed input to input
 * keeps the keyboard up). The input removes itself on blur.
 */
export function bridgeKeyboardFocus(): void {
  if (typeof document === "undefined") return;
  const input = document.createElement("input");
  input.setAttribute("aria-hidden", "true");
  input.tabIndex = -1;
  // Fixed and transparent so focusing it neither scrolls nor shows anything.
  input.className = "fixed top-0 left-0 size-px opacity-0 text-base";
  const remove = () => input.remove();
  input.addEventListener("blur", remove, { once: true });
  // A field that never arrives must not leave the keyboard parked on nothing.
  setTimeout(() => {
    if (document.activeElement === input) input.blur();
    remove();
  }, 1000);
  document.body.appendChild(input);
  input.focus({ preventScroll: true });
}
